import { render } from "./NotificationSignup.vue?vue&type=template&id=61ecd697&scoped=true"
import script from "./NotificationSignup.vue?vue&type=script&lang=js"
export * from "./NotificationSignup.vue?vue&type=script&lang=js"

import "./NotificationSignup.vue?vue&type=style&index=0&id=61ecd697&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ecd697"]])

export default __exports__